var map = {
	"./file_audio.svg": "696a",
	"./file_excel.svg": "e916",
	"./file_folder.svg": "1600",
	"./file_other.svg": "2725",
	"./file_pdf.svg": "1283",
	"./file_picture.svg": "f9a3",
	"./file_ppt.svg": "2b6e",
	"./file_video.svg": "408b",
	"./file_word.svg": "65b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e43f";